import { useTranslation } from 'react-i18next';
import Image1 from '../assets/webp/Image1.webp';
import Bienvenido2 from '../assets/webp/Bienvenido2.webp';
import Welcome2 from '../assets/webp/Welcome2.webp';

const Hero = () => {
  const { t } = useTranslation();

  // Obtener el nombre de la imagen basado en el idioma
  const imageName = t('hero.image');
  // Seleccionar la imagen correcta
  const heroImage = imageName === 'Bienvenido2.webp' ? Bienvenido2 : Welcome2;

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className=' hero-texts'>
        <div className="purple-title ">
        <h1 className="font-archivo font-medium text-greyBase tracking-wide">
          {t('hero.business_support')}
        </h1>
        </div>
        <div className='space-y-0 mb:space-y-1 tabs:space-y-1'>
          <h1 className="font-archivo text-primary font-bold resp-h1" style={{ letterSpacing: '4px' }}>
            {t('hero.main_title')}
          </h1>
            <h2 className="font-sans text-secondary font-semibold text-h3 mb:resp-h4"style={{ lineHeight: '130%' }}>
              {t('hero.subtitle').split('\\n').map((line, idx) => (
                <span key={idx}>
                  {line}
                  {idx !== t('hero.subtitle').split('\\n').length - 1 && <br />}
                </span>
              ))}
            </h2>
            <span className="block w-full h-auto">
              <img 
                src={heroImage}  
                alt="Gráfico" 
                className='w-4/5'
              />
            </span>
        </div>
      
          <p className="font-sans hero-p resp-body5">
            {t('hero.description')}
          </p>
          <button className="font-archivo resp-body5 btn-secondary mt-4"
          onClick={() => window.open("https://wa.toolia.site/cursos2tor", "_blank")}
          > 
            {t('hero.demo_btn')}
          </button>
        </div>
    
      </div>
      <div className="image-container">
        <img src={Image1} alt="Gráfico" className=" animate-float"/>
      </div>

    </section>
  );
};

export default Hero;
